import { Center, Loader, Paper, Table, Text, Title, createStyles } from "@mantine/core"
import { formatDateTime } from "@medplum/core";
import { StatusBadge, useMedplum } from "@medplum/react";
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";

const useStyles = createStyles((theme) => ({
    table: {
        marginTop: "30px"
    },
    thead: {
        backgroundColor: '#BEDEF8',
        borderRadius: 4,
    },
}));

export const Procedure = () => {
    const { patientId } = useParams()
    const { classes } = useStyles();
    const medplum = useMedplum();
    const [procedure, setProcedure] = useState<any>([]);
    const [isFetching, setIsFetching] = useState<boolean>(true);
    const tableHeaders = ["Procedure Name", "Start Date", "End Date", "Clinical Status"]

    useEffect(() => {
        getProcedure()
    }, [patientId])

    const getProcedure = async () => {
        const res = await medplum.searchResources('Procedure', `patient=Patient/${patientId}`)
        setIsFetching(false)
        setProcedure(res)
    }

    return (
        <>
            <Paper
                sx={{
                    marginTop: "20px",
                    borderRadius: "8px",
                    marginLeft: "0px",
                    marginRight: "0px",
                    padding: "20px",
                    background: "'#FFF",
                    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
                }}
                withBorder
            >
                <Title>
                    Procedures
                </Title>
                <Table className={classes.table}>
                    <thead className={classes.thead}>
                        <tr>
                            {
                                tableHeaders.map((val) => {
                                    return (
                                        <th key={val}>
                                            {val}
                                        </th>
                                    )
                                })
                            }
                        </tr>
                    </thead>
                    {
                        <tbody>
                            {
                                procedure.map((data: any) => (
                                    <tr key={data.id}>
                                        <td>{data.code.text}</td>
                                        <td>{formatDateTime(data?.performedPeriod?.start || data.performedDateTime as string)}</td>
                                        <td>{formatDateTime(data.performedPeriod?.end || data.performedDateTime as string)}</td>
                                        <td><StatusBadge status={data.status as string} /></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    }
                </Table>
                {(procedure?.length === 0 && !isFetching) && (
                    <Center style={{ width: "100%", height: "200px" }}>
                        <Text size="xl" color="dimmed">
                            No results
                        </Text>
                    </Center>
                )}
                {
                    isFetching &&
                    <Center style={{ width: "100%", height: "200px" }}>
                        <Loader />
                    </Center>
                }
            </Paper>
        </>
    )
}